// extracted by mini-css-extract-plugin
export default {"header":"styles_header__VEsJN","headerCell":"styles_headerCell__FaUYh"};